import { Roles } from "../../../constants/roles";
import { FormBase } from "../../../util/form-base-form";

export class NavbarHamburgerForm extends FormBase {
    public root: HTMLElement;

    public constructor(root: HTMLElement) {
        super();
        this.root = root;
    }

    public static getRoots(root: ParentNode): HTMLElement[] {
        return new NavbarHamburgerForm(document.body).queryElements(
            root,
            `[data-role="${Roles.NAVBAR_CONTENT}"]`,
            HTMLElement,
        );
    }

    public getRoot(): HTMLElement {
        return this.root;
    }

    public getToggle(): HTMLButtonElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.NAVBAR_HAMBURGER_TOGGLE}"]`, HTMLButtonElement);
    }

    public getCollapsible(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.NAVBAR_COLLAPSIBLE}"]`, HTMLElement);
    }

    public getOverlay(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.NAVBAR_HAMBURGER_OVERLAY}"]`, HTMLElement);
    }

    public getNavbarTop(): HTMLElement | null {
        return this.queryElement(this.root, ".navbar-top", HTMLElement);
    }

    public getLinkTarget(target: EventTarget | Element | null | undefined): HTMLAnchorElement | null {
        return this.closest(target, "a[href]", HTMLAnchorElement);
    }

    public isInitialized(): boolean {
        return this.root.dataset.navbarHamburgerInit === "1";
    }

    public markInitialized(): void {
        this.root.dataset.navbarHamburgerInit = "1";
    }

    public isExpanded(): boolean {
        return this.root.classList.contains("is-mobile-open");
    }

    public setExpanded(expanded: boolean): void {
        this.root.classList.toggle("is-mobile-open", expanded);

        const toggle = this.getToggle();
        if (toggle instanceof HTMLButtonElement) {
            toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
        }

        if (expanded) {
            // Drawer/overlay start below navbar-top (not top:0) so they never cover
            // the still-visible header. Measured on each open since the header's own
            // height varies (e.g. the app name wrapping to 2 lines on narrow phones).
            const navbarTop = this.getNavbarTop();
            if (navbarTop instanceof HTMLElement) {
                this.root.style.setProperty("--navbar-mobile-header-height", `${navbarTop.offsetHeight}px`);
            }
        }
    }

    public setCollapsibleHidden(hidden: boolean): void {
        const collapsible = this.getCollapsible();
        if (collapsible instanceof HTMLElement) {
            collapsible.hidden = hidden;
        }
    }
}
